import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useToast } from '../../hooks/useToast';
import PDFViewer from '../../Menu/Workflows/PDFViewer';

const TreasuryPaymentViewerPage = () => {
  const { fileId } = useParams();
  const navigate = useNavigate();
  const { showError } = useToast();
  const [fileName, setFileName] = useState('');
  const [workflowDefinitionSnowflakeId, setWorkflowDefinitionSnowflakeId] = useState(null);
  const [fastApiFileInstanceId, setFastApiFileInstanceId] = useState(null);
  const [workflowInstanceId, setWorkflowInstanceId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFile = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        if (!token) throw new Error('No authentication token found');
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}conductor/file-instances/${fileId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        if (!res.ok) throw new Error(`Failed to fetch file: ${res.status}`);
        const data = await res.json();
        setFileName(data?.name || data?.file_name || '');
        setWorkflowDefinitionSnowflakeId(
          data?.workflowDefinitionSnowflakeId ||
            data?.workflow_definition_snowflake_id ||
            data?.workflow_definition_id ||
            null
        );

        // Try multiple possible fields for fastApiFileInstanceId; fallback to the provided fileId
        const resolvedFastApiId =
          data?.fastApiFileInstanceId ||
          data?.fast_api_file_instance_id ||
          data?.integrationId || // integrationId maps to fast api file id in payments endpoints
          data?.file_instance_id ||
          data?.id ||
          fileId;
        setFastApiFileInstanceId(resolvedFastApiId);

        // Try multiple possible fields for workflowInstanceId
        const resolvedWorkflowInstanceId =
          data?.workflowInstanceId ||
          data?.workflow_instance_id ||
          data?.processId || // processId maps to workflow instance id for payments
          data?.workflowExecutionId ||
          data?.executionId ||
          data?.workflow_execution_id ||
          null;
        setWorkflowInstanceId(resolvedWorkflowInstanceId);
      } catch (err) {
        console.error('Error fetching file instance:', err);
        showError('Failed to load file details');
      } finally {
        setLoading(false);
      }
    };

    if (fileId) fetchFile();
  }, [fileId, showError]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!fileId) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">No file specified</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <PDFViewer
        fileInstanceId={fileId}
        fastApiFileInstanceId={fastApiFileInstanceId}
        fileName={fileName}
        workflowInstanceId={workflowInstanceId}
        workflowDefinitionSnowflakeId={workflowDefinitionSnowflakeId}
        onBack={() => navigate(-1)}
        onBackToWorkflows={() => navigate('/treasury-payment/workflows')}
        selectedDocumentType={'Treasury Payment'}
      />
    </Box>
  );
};

export default TreasuryPaymentViewerPage;

